import { render, staticRenderFns } from "./TaskListDialog.vue?vue&type=template&id=0511372a&scoped=true"
import script from "./TaskListDialog.vue?vue&type=script&lang=js"
export * from "./TaskListDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskListDialog.vue?vue&type=style&index=0&id=0511372a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0511372a",
  null
  
)

export default component.exports